export enum ApplicationSection {    
    ADJ = "Adjuster",
    CLR = "Claim Report",
    EST = "Estimate", 
    ICD = "Insurance Company Documents",
    INV = "Invoice",
    LNS = "Loss Notification",
    MGR = "Merged Report",
    NON = "None",
}

export enum CLAIM_ACTION_STATUSES {
    DELETING_ATTACHMENT = 'DELETING_ATTACHMENT', 
    DELETE_ATTACHMENT_SUCCESS = 'DELETE_ATTACHMENT_SUCCESS', 
    DELETE_ATTACHMENT_FAILED = 'DELETE_ATTACHMENT_FAILED',    
    UPDATING_PROFILE = 'UPDATING_PROFILE', 
    UPDATING_PROFILE_SUCCESS = 'UPDATING_PROFILE_SUCCESS',
    UPDATING_PROFILE_FAILURE = 'UPDATING_PROFILE_FAILURE', 
}

// moving claim action statuses over to user actions...
export enum USER_ACTIONS {
    AI_TOOL_PUBLISHED = 'AI_TOOL_PUBLISHED',
    AI_TOOL_PUBLISH_FAILURE = 'AI_TOOL_PUBLISH_FAILURE',
    INIT = 'INIT',
    BULK_ASSIGN_CLAIMS = 'BULK_ASSIGN_CLAIMS', 
    BULK_ASSIGN_CLAIMS_SUCCESS = 'BULK_ASSIGN_CLAIMS_SUCCESS',
    BULK_ASSIGN_CLAIMS_FAILURE = 'BULK_ASSIGN_CLAIMS_FAILURE',
    CLAIM_CREATING = 'CLAIM_CREATING', 
    CLAIM_CREATING_FAILURE = 'CLAIM_CREATING_FAILURE',
    CLAIM_CREATING_SUCCESS = 'CLAIM_CREATING_SUCCESS',     
    CLAIM_CREATING_INVOICE = 'CLAIM_CREATING_INVOICE',    
    CLAIM_CREATE_INVOICE_FAILURE = 'CLAIM_CREATE_INVOICE_FAILURE', 
    CLAIM_CREATE_INVOICE_SUCCESS = 'CLAIM_CREATE_INVOICE_SUCCESS',
    CLAIM_CREATING_POLICY = 'CLAIM_CREATING_POLICY', 
    CLAIM_CREATE_POLICY_FAILURE = 'CLAIM_CREATE_POLICY_FAILURE', 
    CLAIM_CREATE_POLICY_SUCCESS = 'CLAIM_CREATE_POLICY_SUCCESS', 
    CLAIM_LOADING = 'CLAIM_LOADING', 
    CLAIM_LOADING_FAILURE = 'CLAIM_LOADING_FAILURE', 
    CLAIM_LOADING_SUCCESS = 'CLAIM_LOADING_SUCCESS', 
    CLAIM_SEARCHING = 'CLAIM_SEARCHING', 
    CLAIM_SEARCH_FAILURE = 'CLAIM_SEARCH_FAILURE', 
    CLAIM_SEARCH_SUCCESS = 'CLAIM_SEARCH_SUCCESS', 
    CLAIM_UPDATING = 'CLAIM_UPDATING', 
    CLAIM_UPDATE_FAILURE = 'CLAIM_UPDATE_FAILURE', 
    CLAIM_UPDATE_SUCCESS = 'CLAIM_UPDATE_SUCCESS', 
    COMPANY_CREATING = 'COMPANY_CREATING',
    COMPANY_CREATE_FAILURE = 'COMPANY_CREATE_FAILURE',
    COMPANY_CREATE_SUCCESS = 'COMPANY_CREATE_SUCCESS',
    COMPANY_UPDATING = 'COMPANY_UPDATING', 
    COMPANY_UPDATE_FAILURE = 'COMPANY_UPDATE_FAILURE', 
    COMPANY_UPDATE_SUCCESS = 'COMPANY_UPDATE_SUCCESS',
    CONTACT_MERGING = 'CONTACT_MERGING', 
    CONTACT_MERGE_FAILURE = 'CONTACT_MERGE_FAILURE', 
    CONTACT_MERGE_SUCCESS = 'CONTACT_MERGE_SUCCESS',
    CONTACT_SYNCING = 'CONTACT_SYNCING',
    CONTACT_SYNC_FAILURE = 'CONTACT_SYNC_FAILURE', 
    CONTACT_SYNC_SUCCESS = 'CONTACT_SYNC_SUCCESS', 
    INVOICE_ADD_CORRECTION = 'INVOICE_ADD_CORRECION', 
    INVOICE_ADD_CORRECTION_SUCCESS = 'INVOICE_ADD_CORRECION_SUCCESS', 
    INVOICE_ADD_CORRECTION_FAILURE = 'INVOICE_ADD_CORRECION_FAILURE', 
    INVOICE_BUILDING_PDF = 'INVOICE_BUILDING_PDF',
    INVOICE_BUILD_PDF_SUCCESS = 'INVOICE_BUILD_PDF_SUCCESS',
    INVOICE_BUILD_PDF_FAILURE = 'INVOICE_BUILD_PDF_FAILURE', 
    INVOICE_CSV_DOWNLOADING = 'INVOICE_CSV_DOWNLOADING', 
    INVOICE_CSV_DOWNLOAD_SUCCESS = 'INVOICE_CSV_DOWNLOAD_SUCCESS', 
    INVOICE_CSV_DOWNLOAD_FAILURE = 'INVOICE_CSV_DOWNLOAD_FAILURE', 
    INVOICE_SAVING = 'INVOICE_SAVING', 
    INVOICE_SAVING_FAILURE = 'INVOICE_SAVING_FAILURE', 
    INVOICE_SAVING_SUCCESS = 'INVOICE_SAVING_SUCCESS',
    INVOICE_DELETING = 'INVOICE_DELETING', 
    INVOICE_DELETE_FAILURE = 'INVOICE_DELETE_FAILURE', 
    INVOICE_DELETE_SUCCESS = 'INVOICE_DELETE_SUCCESS', 
    PAYROLL_CREATING = 'PAYROLL_CREATING', 
    PAYROLL_CREATING_SUCCESS = 'PAYROLL_CREATING_SUCCESS', 
    PAYROLL_CREATING_FAILURE = 'PAYROLL_CREATING_FAILURE', 
    PAYROLL_DELETING = 'PAYROLL_DELETING', 
    PAYROLL_DELETING_FAILURE = 'PAYROLL_DELETING_FAILURE', 
    PAYROLL_DELETING_SUCCESS = 'PAYROLL_DELETING_SUCCESS',
    PAYROLL_GETTING_ZIP  = 'PAYROLL_GETTING_ZIP', 
    PAYROLL_GETTING_ZIP_FAILURE = 'PAYROLL_GETTING_ZIP_FAILURE', 
    PAYROLL_GETTING_ZIP_SUCCESS = 'PAYROLL_GETTING_ZIP_SUCCESS',
    POLICY_UPDATING = 'POLICY_UPDATING', 
    POLICY_UPDATE_FAILURE = 'POLICY_UPDATE_FAILURE', 
    POLICY_UPDATE_SUCCESS = 'POLICY_UPDATE_SUCCESS',
    USER_UPDATING = 'USER_UPDATING',
    USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE',
    USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS',
}

export enum USER_PERMISSIONS {
    ADJ_SCORECARD_READ = 'Adj Scorecard - Read',
    ADJ_SCORECARD_ADMIN = 'Adj Scorecard - Admin',
    ASSIGNMENT_QUEUE = 'Assignment Queue', 
    CAN_EDIT_INVOICE_FEE_TAX_STATUS = 'Invoicing - Can update tax flag',
    CAN_MANAGE_CONNECT_LINK = 'Can Manage Connect Link', 
    PAYROLL_CAN_ACCESS = 'Access Payroll', 
    DASHBOARDS_ADJUSTER_ALL = 'Adjuster Dashboard - All',     
    INVOICING_CAN_CREATE = 'Can create invoices', 
    INVOICING_CAN_EDIT = 'Can Edit Invoice', 
    INVOICING_CAN_EDIT_PAID = 'Invoicing - Can Edit Paid',
    INVOICING_CAN_EDIT_PDFd = 'Can Edit PDFd Invoices', 
    INVOICING_CAN_FINALIZE = 'Can approve/finalize invoice', 
    INVOICING_CAN_ZERO = 'Invoicing - Can Zero',
    INVOICING_CAN_ZERO_DELETE = 'Can delete/zero out invoice', 
}
